import type { ComponentProps } from 'react'
import { Tabs as TabsPrimitive } from '@base-ui/react/tabs'

import { cn } from '@/lib/utils'

const tabsTabClassName = 'text-muted-foreground hover:text-foreground hover:bg-muted focus-visible:border-foreground focus-visible:ring-foreground/40 data-active:bg-muted data-active:text-foreground inline-flex h-7 shrink-0 items-center gap-1.5 rounded-md border border-transparent px-2.5 text-xs font-medium whitespace-nowrap transition-colors outline-none select-none focus-visible:ring-2 data-disabled:pointer-events-none data-disabled:opacity-50'

function Tabs({ className, ...props }: ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root data-slot="tabs" className={cn('min-w-0', className)} {...props} />
}

function TabsList({ className, ...props }: ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn('flex items-center gap-1', className)}
      {...props}
    />
  )
}

function TabsTab({ className, ...props }: ComponentProps<typeof TabsPrimitive.Tab>) {
  return (
    <TabsPrimitive.Tab
      data-slot="tabs-tab"
      className={cn(tabsTabClassName, className)}
      {...props}
    />
  )
}

const pageTabsClassName = 'border-border flex gap-6 overflow-x-auto border-b px-6'

const pageTabClassName = 'text-muted-foreground hover:text-foreground hover:not-aria-[current=page]:border-border aria-[current=page]:border-primary aria-[current=page]:text-foreground aria-[current=page]:font-medium focus-visible:ring-ring/30 flex h-9 shrink-0 items-center border-b-2 border-transparent px-0.5 text-xs whitespace-nowrap transition-colors outline-none focus-visible:ring-2 focus-visible:ring-inset'

export { Tabs, TabsList, TabsTab, pageTabClassName, pageTabsClassName, tabsTabClassName }
